/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equivalence_TitleInputs */

const en_us2_equivalence_title = /** @type {(inputs: Equivalence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the scale`)
};

const pt_br2_equivalence_title = /** @type {(inputs: Equivalence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na balança`)
};

const es_419_equivalence_title = /** @type {(inputs: Equivalence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la balanza`)
};

const pt_pt2_equivalence_title = /** @type {(inputs: Equivalence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na balança`)
};

const fr_fr2_equivalence_title = /** @type {(inputs: Equivalence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sur la balance`)
};

const de_de2_equivalence_title = /** @type {(inputs: Equivalence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf der Waage`)
};

const it_it2_equivalence_title = /** @type {(inputs: Equivalence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulla bilancia`)
};

/**
* | output |
* | --- |
* | "On the scale" |
*
* @param {Equivalence_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equivalence_title = /** @type {((inputs?: Equivalence_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equivalence_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equivalence_title(inputs)
	if (locale === "es-419") return es_419_equivalence_title(inputs)
	if (locale === "pt-PT") return pt_pt2_equivalence_title(inputs)
	if (locale === "fr-FR") return fr_fr2_equivalence_title(inputs)
	if (locale === "de-DE") return de_de2_equivalence_title(inputs)
	if (locale === "it-IT") return it_it2_equivalence_title(inputs)
	return en_us2_equivalence_title(inputs)
});
export { equivalence_title as "equivalence.title" }